import { ReactComponent as CardAmexIcon } from 'src/assets/icons/card-amex.svg';
import { ReactComponent as CardDinersIcon } from 'src/assets/icons/card-diners.svg';
import { ReactComponent as CardEloIcon } from 'src/assets/icons/card-elo.svg';
import { ReactComponent as CardHiperIcon } from 'src/assets/icons/card-hiper.svg';
import { ReactComponent as CardHipercardIcon } from 'src/assets/icons/card-hipercard.svg';
import { ReactComponent as CardMastercardIcon } from 'src/assets/icons/card-mastercard.svg';
import { ReactComponent as CardVisaIcon } from 'src/assets/icons/card-visa.svg';
import { EventCoupon, CreditCardBrand } from 'src/types/dto';
import { CartItemType } from 'src/types/ui';

export const isCouponValid = (
  discount: EventCoupon | null,
  totalWithoutFees: number,
  item: CartItemType,
) => {
  if (!discount) {
    return false;
  }

  const { unlockPrice, ticketTypes } = discount;

  const isTotalAchieved = !!unlockPrice
    ? totalWithoutFees >= unlockPrice
    : totalWithoutFees > 0;

  const isTypeAvailable =
    ticketTypes?.length === 0 ||
    (ticketTypes?.length > 0 &&
      item.quantity > 0 &&
      ticketTypes.map(tt => tt.id)?.includes(item.ticketTypeId));

  return isTotalAchieved && isTypeAvailable;
};

export const round = (number: number, digits: number | undefined): number =>
  Number(number?.toFixed(digits));

export const getCartItems = (opts: {
  cart: CartItemType[];
  coupon: EventCoupon | null;
}) => {
  const { cart, coupon } = opts;
  let discountApplied = 0;
  const totalCartWithoutFee = cart?.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0,
  );

  const result = cart
    ?.filter(item => item.quantity)
    ?.map(item => {
      const amount = item.quantity * item.price;
      const isCouponApplied = isCouponValid(coupon, totalCartWithoutFee, item);
      let discount = 0;
      if (isCouponApplied) {
        if (!!coupon?.percentageDiscount) {
          discount = round(amount * coupon?.percentageDiscount, 2);
        } else if (
          !!coupon?.priceDiscount &&
          discountApplied < coupon?.priceDiscount
        ) {
          const discountMaybe = coupon?.priceDiscount - discountApplied;
          discount = discountMaybe >= amount ? amount : discountMaybe;
          discountApplied += discountMaybe >= amount ? amount : discountMaybe;
        }
      }
      return {
        total: round(amount, 2),
        creditCardFee: item.quantity * item.taxPrice,
        discount,
        isCouponApplied,
      };
    });
  return result;
};

// const encoder = new TextEncoder();
//     const data = encoder.encode(message);
//     const hash = await crypto.subtle.digest('SHA-256', data);
//     return hash;

export const encryptData = async (data: string) => {
  const encoder = new TextEncoder();
  const encoded = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

export const formatCardNumber = (cardNumber?: string) =>
  cardNumber ? `•••• ${cardNumber}` : '';

export const getBrandCardIcon = (brand?: CreditCardBrand) => {
  if (brand === CreditCardBrand.Amex) return CardAmexIcon;
  if (brand === CreditCardBrand.Diners) return CardDinersIcon;
  if (brand === CreditCardBrand.Elo) return CardEloIcon;
  if (brand === CreditCardBrand.Hiper) return CardHiperIcon;
  if (brand === CreditCardBrand.Hipercard) return CardHipercardIcon;
  if (brand === CreditCardBrand.MasterCard) return CardMastercardIcon;
  if (brand === CreditCardBrand.Visa) return CardVisaIcon;
  return CardVisaIcon;
};
